import React, { useEffect, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import './account.css';
import { getAcountHistory } from '../apiService.js';
import { toast } from 'react-toastify';

function Account({ onClose, walletData }) {

  const formatDateToDisplay = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const getTodayYMD = () => {
    const d = new Date();
    return d.toISOString().split("T")[0];
  };

  const getPastDateYMD = (days) => {
    const d = new Date();
    d.setDate(d.getDate() - days);
    return d.toISOString().split("T")[0];
  };


  const formatDateFromInput = (dateStr) => {
    const [year, month, day] = dateStr.split('-');
    return `${day}-${month}-${year}`;
  };

  const [fromDate, setFromDate] = useState(getPastDateYMD(0)); // default = 8 days ago
  const [toDate, setToDate] = useState(getTodayYMD());         // default = today

  const [filteredData, setFilteredData] = useState({});

  /** FIXED: wrapped inside useCallback to satisfy eslint */
  const handleFetchData = useCallback(async () => {
    const formattedFromDate = formatDateFromInput(fromDate);
    const formattedToDate = formatDateFromInput(toDate);

    if (!fromDate || !toDate) {
      alert("Please select both From and To dates.");
      return;
    }

    try {
      const response = await getAcountHistory(formattedFromDate, formattedToDate);
      setFilteredData(response);
    } catch (error) {
      toast.error("Please Login again, Token Expired!", {
        position: "top-right",
        autoClose: 5000,
      });
    }
  }, [fromDate, toDate]);

  /** FIXED: dependency added */
  useEffect(() => {
    handleFetchData();
  }, [handleFetchData]);

  const closePopup = () => {
    onClose(false);
  };

  const printData = () => {
    try {
      const content = document.querySelector('.print-area');
      if (!content) return;

      const styles = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
        .map((link) => `<link rel="stylesheet" href="${link.href}">`)
        .join('');

      const contentWidth = content.scrollWidth || content.offsetWidth || 1000;

      const winWidth = Math.min(contentWidth + 80, window.screen?.availWidth || 1200);
      const winHeight = Math.min((content.scrollHeight || 800) + 120, window.screen?.availHeight || 1000);

      const nw = window.open('', '_blank', `toolbar=0,location=0,menubar=0,width=${winWidth},height=${winHeight}`);
      nw.document.open();
      nw.document.write(`
        <!doctype html>
        <html>
        <head>
          <title>Print Account</title>
          ${styles}
          <style>
            body { font-family: Arial, Helvetica, sans-serif; padding:18px; color:#000; width:${contentWidth}px; margin:0 auto; }
            table { width:100%; border-collapse:collapse; max-width:none; }
            th, td { border:1px solid #ddd; padding:12px 14px; }
          </style>
        </head>
        <body>
      `);
      nw.document.write(content.innerHTML);
      nw.document.write('</body></html>');
      nw.document.close();

      setTimeout(() => { nw.print(); nw.close(); }, 500);
    } catch (err) {
      console.error('Print failed', err);
    }
  };

  const modal = (
    <div className="popup-overlay" role="dialog" aria-modal="true">
      <div className="popup-container">
        <button className="close-btn" onClick={closePopup}>&times;</button>
        <h2>Wallet Details</h2>

        <div className="balanceAmt">
          <h1><strong>Username:</strong> {walletData[0]?.username || 'N/A'}</h1>
          <h1><strong>Balance Wallet:</strong> {walletData[0]?.balance_wallet || 'N/A'}</h1>
        </div>

        <div className="date-filters">
          <label>From Date:</label>
          <input
            type="date"
            min={getPastDateYMD(8)}
            max={toDate}              // fromDate cannot be greater than toDate
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />


          <label>To Date:</label>
          <input
            type="date"
            min={fromDate}            // toDate cannot be smaller than fromDate
            max={getTodayYMD()}       // max today
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />

          <button onClick={handleFetchData} className="fetch-btn">
            Fetch Data
          </button>
        </div>

        {filteredData && (
          <div className="print-area">
            <div className="print-header" style={{ marginBottom: 12 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 20 }}>
                <div><strong>Username:</strong> {walletData[0]?.username}</div>
                <div><strong>Total Amount:</strong> {filteredData.final_amount ?? filteredData.sale_amount ?? 'N/A'}</div>
              </div>
            </div>

            <h3>Account Data</h3>
            <table className="account-transaction-table">
              <thead>
                <tr>
                  <th>Total Sale</th>
                  <th>Total Winning</th>
                  <th>Total Commission</th>
                  <th>Final Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{filteredData.sale_amount}</td>
                  <td>{filteredData.wining_amount}</td>
                  <td>{filteredData.total_commission}</td>
                  <td>{filteredData.final_amount}</td>
                </tr>
              </tbody>
            </table>

            <button onClick={printData} className="fetch-btn" style={{ marginTop: '20px' }}>
              Print
            </button>
          </div>
        )}
      </div>
    </div>
  );

  return ReactDOM.createPortal(modal, document.body);
}

export default Account;
